(function(){
  function init(){
    var s=document.getElementById('shopify-section-collection_list_fw');
    if(!s)return;
    var items=Array.from(s.querySelectorAll('.resource-list--grid .resource-list__item'));
    if(!items.length)return;
    items[0].classList.add('fw-active');
    items.forEach(function(el){
      el.addEventListener('mouseenter',function(){
        items.forEach(function(i){i.classList.remove('fw-active');});
        el.classList.add('fw-active');
      });
    });
  }
  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',init)
    :init();
})();
